/**
 * Brauzerning o'z kontekst menyusi (foydalanuvchi qoidasi, 2026-10-18): birinchi o'ng bosishda bizning menyu (yoki hech
 * narsa), o'sha joyga ikkinchi o'ng bosishda -- bizning menyu ochiq turganda yoki 1.5 s ichida -- brauzerniki. Istisno:
 * matn maydonlari (nusxalash/qo'yish) va `data-native-menu` belgilangan element -- u yerda brauzer menyusi doim.
 * Ikkinchi bosishda hodisa Radix trigger'iga yetkazilmaydi (stopPropagation), aks holda bizniki qayta ochilardi.
 */
const ALLOW = "input, textarea, [contenteditable='']:not([contenteditable='false']), [contenteditable='true'], [data-native-menu]";
const NEAR_PX = 24;
const SECOND_CLICK_MS = 1500;

type ClosestTarget = { closest: (selector: string) => unknown };

export function shouldAllowNativeMenu(target: unknown): boolean {
  const el = target && typeof (target as ClosestTarget).closest === "function" ? (target as ClosestTarget) : null;
  return !!el?.closest(ALLOW);
}

export interface ContextMenuLike {
  isTrusted: boolean;
  target: unknown;
  clientX: number;
  clientY: number;
  preventDefault(): void;
  stopPropagation(): void;
}

export function createNativeMenuGuard(now: () => number = () => Date.now()) {
  let last: { x: number; y: number; t: number } | null = null; // oxirgi to'xtatilgan o'ng bosish
  let armed = false; // o'ng tugma bosilganda bizning menyu ochiq edi
  const near = (e: { clientX: number; clientY: number }) => !!last && Math.abs(e.clientX - last.x) <= NEAR_PX && Math.abs(e.clientY - last.y) <= NEAR_PX;
  return {
    onPointerDown(e: { button: number }, customMenuOpen: boolean) {
      if (e.button === 2) armed = customMenuOpen;
    },
    /** Capture bosqichi (Radix'dan oldin): ikkinchi bosish bo'lsa hodisa bizning menyuga yetmaydi -- brauzerniki ochiladi. true -- brauzerniki */
    onContextMenuCapture(e: ContextMenuLike): boolean {
      if (!e.isTrusted) return false; // bizning "⋯" tugmasi yuboradigan sun'iy hodisa -- Radix'ga
      if (shouldAllowNativeMenu(e.target)) return true;
      const second = near(e) && (armed || (last !== null && now() - last.t <= SECOND_CLICK_MS));
      armed = false;
      if (!second) return false;
      last = null;
      e.stopPropagation();
      return true;
    },
    /** Bubble bosqichi (Radix o'z menyusini ochib bo'lgach): brauzer menyusi to'xtatiladi, joy eslab qolinadi */
    onContextMenuBubble(e: ContextMenuLike) {
      if (!e.isTrusted || shouldAllowNativeMenu(e.target)) return;
      e.preventDefault();
      last = { x: e.clientX, y: e.clientY, t: now() };
    },
  };
}

export function isCustomMenuOpen(doc: Pick<Document, "querySelector"> = document): boolean {
  return !!doc.querySelector('[role="menu"][data-state="open"]');
}

export function installNativeMenuGuard(doc: Document = document) {
  const guard = createNativeMenuGuard();
  doc.addEventListener("pointerdown", (e) => guard.onPointerDown(e, isCustomMenuOpen(doc)), true);
  // Capture'da preventDefault qilinmaydi: Radix `defaultPrevented` bo'lsa o'z menyusini ochmaydi (2026-10-18 da shu xato bo'ldi)
  doc.addEventListener("contextmenu", (e) => guard.onContextMenuCapture(e), true);
  doc.addEventListener("contextmenu", (e) => guard.onContextMenuBubble(e));
}
